// extracted by mini-css-extract-plugin
module.exports = {"component":"Login_component__4AJyQ","cover":"Login_cover__83NFp","Button":"Login_Button__zjTRJ","text":"Login_text__GUrYA"};